<template>
  <div v-if="regularPrice !== discountedPrice">
    <div class="d-sm-flex align-center">
      <span class="blue--text text--lighten-3 mr-4 text-decoration-line-through d-block">{{ regularPrice }} &euro;</span>
      <strong :class="{'text-h6': strong}" class="font-weight-bold discounted-price d-block">{{ discountedPrice }} &euro;</strong>
    </div>
  </div>
  <div v-else>
    <strong :class="{'text-h6': strong}" class="font-weight-bold">{{ discountedPrice }} &euro;</strong>
  </div>
</template>

<script>
import {getCartProductPrice, getCartProductPriceWithDiscount} from "@/utils";

export default {
  name: "PriceDisplay",
  computed: {
    // Price with discount if at least one
    discountedPrice() {
      const price = getCartProductPriceWithDiscount(this.$props.numberOfDays, this.$props.cartProduct);
      let roundedPrice = price.toFixed(1);

      return this.round ? Number(roundedPrice) : Number(price);
    },
    // Price without discount
    regularPrice() {
      const price = getCartProductPrice(this.$props.numberOfDays, this.$props.cartProduct);
      let roundedPrice = price.toFixed(1);

      return this.round ? Number(roundedPrice) : Number(price);
    },
  },
  props: {
    cartProduct: {
      type: Object,
      required: true
    },
    numberOfDays: {
      type: Number,
      required: true
    },
    round: {
      type: Boolean,
      required: false,
      default: true
    },
    strong: {
      type: Boolean,
      required: false,
      default: false
    }
  }
}
</script>

<style scoped>

</style>
